import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { PlausibilitaetEntity } from '../../../entities/mdqx/plausibilitaet.entity';
import { PlausibilitaetActions, PlausibilitaetActionTypes } from '../../actions/mdqx/plausibilitaet.actions';

export interface PlausibilitaetState extends EntityState<PlausibilitaetEntity> {
    fetched: boolean;
}

export const PLAUSIBILITAET_KEY = 'plausibilitaet';

const adapter = createEntityAdapter<PlausibilitaetEntity>({
    selectId: plausibilitaet => plausibilitaet.Id,
});

const initialState: PlausibilitaetState = adapter.getInitialState({
    fetched: false,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export function plausibilitaetReducer(state = initialState, action: PlausibilitaetActions) {
    switch (action.type) {
        case PlausibilitaetActionTypes.GetPlausibilitaetenResponse: {
            return adapter.setAll(action.Payload, { ...state, fetched: true });
        }

        default: {
            return state;
        }
    }
}

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectAll } = adapter.getSelectors();

export const selectAllPlausibilitaeten = selectAll;

export const selectPlausibilitaetenFetched = (state: PlausibilitaetState) => state.fetched;
